import { render, staticRenderFns } from "./HomeGoodsCard.vue?vue&type=template&id=094384c9&scoped=true"
import script from "./HomeGoodsCard.vue?vue&type=script&lang=js"
export * from "./HomeGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./HomeGoodsCard.vue?vue&type=style&index=0&id=094384c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094384c9",
  null
  
)

export default component.exports